import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  TextField,
  Grid,
  InputLabel,
  Paper,
  IconButton,
  Select,
  MenuItem,
} from '@mui/material';
import useStyles from './styles';
import EnhancedTable from '../../table-old';
import { AppState } from '../../../store';
import { HeadCell } from '../../table-old/components/expandable-row';
import DeleteIcon from '../../../assets/icons/delete-icon';
import { enqueueSnackbarAction } from '../../../store/snackbar/actions';
import { createSFTPUser } from '../../../store/sftp/actions';

const emailRegex = /^(([^\s"(),.:;<>@[\]]+(\.[^\s"(),.:;<>@[\]]+)*)|(".+"))@(([^\s"(),.:;<>@[\]]+\.)+[^\s"(),.:;<>@[\]]{2,})$/i;

type SelectOption = {
  value: string;
  title: string;
};

const userTypes: SelectOption[] = [
  { title: 'Customer', value: 'Customer' },
  { title: 'Dealer', value: 'Dealer' },
];

const VIMSSFTPCreation = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { client } = useSelector((state: AppState) => state.login);
  const clientAuth: any = client?.authenticate();
  const userName = clientAuth.loginId;

  const [userType, setUserType] = useState<string>('');
  const [userCode, setUserCode] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [selectedEmailIds, setSelectedEmailIds] = useState<any>([]);
  const [associatedName, setAssociatedName] = useState<string>('');
  const [emails, setEmails] = useState<any>([]);
  const [result, setResult] = useState<any>(null);

  const headCellsEmail: HeadCell[] = [
    {
      id: 'email',
      numeric: false,
      disablePadding: true,
      label: 'Associated Email Addresses',
      accessor: 'row.email',
    },
  ];

  const clearState = () => {
    setUserType('');
    setAssociatedName('');
    setEmail('');
    setUserCode('');
    setEmails([]);
    setResult(null);
  }

  const enableButton = () => {
    if (userType !== '' && userCode !== '' && emails.length !== 0 && associatedName !== '') return false;
    return true;
  }

  const updateEmail = () => {
    const emailList = emails.map((item: any) => item.id);
    if (!emailList.includes(email)) {
      const selectEmails = [...selectedEmailIds, email];
      setSelectedEmailIds(selectEmails);
      const emailObject = { id: email, email };
      setEmails([...emails, emailObject]);
      setEmail('');
    } else {

      dispatch(
        enqueueSnackbarAction({
          message: 'Associated Email already exists',
          options: { key: email, variant: 'error' },
        }),
      );
    }
  }

  const removeEmail = () => {
    const remainingEmails = emails.filter((email: { id: any; }) => !selectedEmailIds.includes(email.id));
    setEmails(remainingEmails);
  }

  const handleUserCreate = async () => {
    const associatedEmailAddresses = emails.map((item: any) => item.id);
    const bulkCreate = {
      vimsSftpUsers: [
        {
          userType,
          userCode,
          associatedEmailAddresses,
          associatedName,
        }
      ],
      userId: userName,
    }
    const sftpUsers: object | null = await dispatch(createSFTPUser(bulkCreate));
    if (sftpUsers) {
      setResult(sftpUsers);
    }
  };

  return (
    <div >
      <Grid container direction="row" alignItems="stretch">
        <Grid item xs={12} lg={6} className={classes.vimsSearchContainer}>
          <Box p={2} className={classes.box} >
            <InputLabel className={classes.label}>User Type</InputLabel>
            <Select
              variant="standard"
              id="dataFileOnDemandSelect"
              value={userType || 'select'}
              onChange={(event) => setUserType(event.target.value as string)}
              className={classes.dropdown}
            >
              <MenuItem value="select">
                <em className={classes.unSelected}>Select</em>
              </MenuItem>
              {(userTypes as Array<SelectOption>).map((o: SelectOption) => (
                <MenuItem value={o.value}>{o.title}</MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>

        <Grid item xs={12} lg={6} >
          <Box p={2} className={classes.box}>
            <InputLabel className={classes.label}>User Code</InputLabel>
            <TextField className={classes.textBox} variant="standard"
              value={userCode}
              onChange={(event) => {
                setUserCode(event.target.value as string);
                return event.target.value;
              }} />
          </Box>
        </Grid>

        <Grid item xs={12} lg={6} >
          <Box p={2} className={classes.box}>
            <InputLabel className={classes.label} >Associated Email</InputLabel>
            <TextField className={classes.textBox} variant="standard" value={email}
              onChange={(event) => {
                setEmail(event.target.value as string);
                return event.target.value;
              }} />

            <Button
              variant="outlined"
              className={classes.button}
              disabled={!emailRegex.test(email)}
              sx={{ marginLeft: '10px' }}
              onClick={updateEmail}
            >
              Add
            </Button>

          </Box>

          <Box p={2}>
            {selectedEmailIds.length > 0 && emails.length > 0 && (
              <IconButton
                style={{ float: 'left', width: '5%' }}
                id="deleteButton"
                onClick={() => removeEmail()}
                aria-label="delete"
                className={classes.delete}
              >
                <DeleteIcon />
              </IconButton>
            )}
            <Paper style={{ marginRight: '0px', marginLeft: '0px', width: '100%', float: 'right' }}>
              <EnhancedTable
                initialSort="modifiedDateTime"
                id="dealerEmailsTable"
                rows={emails}
                headCells={headCellsEmail}
                expandableData={[]}
                selectableRows={(selection: any) => {
                  setSelectedEmailIds(selection);
                }}
              />
            </Paper>
          </Box>

        </Grid>

        <Grid item xs={12} lg={6} >
          <Box p={2} className={classes.box}>
            <InputLabel className={classes.label}>Associated Name</InputLabel>
            <TextField className={classes.textBox} variant="standard"
              value={associatedName}
              onChange={(event) => {
                setAssociatedName(event.target.value as string);
                return event.target.value;
              }} />
          </Box>


          {result?.username &&
            <>
              <br />
              <Box p={2} className={classes.box}>
                <InputLabel className={classes.label}><b style={{ color: 'green' }}>Username</b></InputLabel>
                <b style={{ color: 'green' }}>{result.username}</b>
              </Box>
            </>
          }

          {result?.sftpServerEndpoint &&
            <>
              <br />
              <Box p={2} className={classes.box}>
                <InputLabel className={classes.label}><b style={{ color: 'green' }}>SFTP Server Endpoint</b></InputLabel>
                <b style={{ color: 'green' }}>{result.sftpServerEndpoint}</b>
              </Box>
            </>
          }
        </Grid>

        <Grid item xs={12} lg={12} >
          <Box p={3} className={classes.flexBox}  >
            <Button
              variant="outlined"
              className={classes.button}
              onClick={handleUserCreate}
              disabled={enableButton()}
            >
              CREATE
            </Button>

            <Button
              variant="outlined"
              style={{ marginLeft: 10 }}
              onClick={clearState}
            >
              Clear
            </Button>
          </Box>

        </Grid>


      </Grid>
    </div>
  );
}
export default VIMSSFTPCreation;